<template>
  <layout>
    <template slot="header">
      {{ localEntity.id ? 'Edit' : 'Add' }} group
    </template>
    <template>
      <v-form class="pa-4" ref="form" v-model="isValid" lazy-validation>
        <v-text-field
          data-test="groupName"
          v-model="localEntity.groupName"
          label="Name"
          :rules="[required]"
          clearable
        ></v-text-field>
        <div>
          <subheader>Description</subheader>
          <v-textarea
            data-test="groupDescription"
            v-model="localEntity.description"
            no-resize
            rows="1"
            auto-grow
          ></v-textarea>
        </div>
        <v-btn
          data-test="copyUuid"
          v-if="localEntity.id"
          color="primary"
          class="mb-4"
          style="width: 100%"
          outlined
          :loading="false"
          @click.stop="copy"
        >
          copy uuid
        </v-btn>
        <v-btn
          data-test="deleteGroup"
          v-if="localEntity.id"
          color="error"
          style="width: 100%"
          depressed
          :loading="false"
          @click.stop="handleDeleteGroup"
        >
          delete group
        </v-btn>
      </v-form>
    </template>

    <template slot="footer">
      <v-spacer />
      <v-btn text :loading="false" @click="close">
        cancel
      </v-btn>
      <v-btn
        color="primary"
        text
        :loading="false"
        data-test="saveOrAddGroup"
        @click="apply"
      >
        {{ localEntity.id ? 'Save' : 'Add' }}
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { ref, onMounted } from '@vue/composition-api';
import useUsers from '@/api/users';
import copyToClipboard from '@/utils/copyToClipboard';
import DefaultConfirmation from '@/components/app-entity/modals/DefaultConfirmation';
import useCommonModal from '@/compositions/useCommonModal';

export default {
  name: 'addGroup',
  props: ['group'],
  components: {
    Layout,
    DefaultConfirmation
  },
  setup(props, { root, refs, emit }) {
    const { groups: groupsApi, group: groupApi } = new useUsers();
    const modalComposition = useCommonModal();
    const { list: groups } = groupsApi;
    groupsApi.load();
    const { item: localEntity } = groupApi;

    const errors = ref({});
    const isValid = ref(true);

    const confirm = ref(false);

    function required(value) {
      return !!value || 'Required.';
    }

    async function apply() {
      refs.form.validate();

      await root.$nextTick();
      if (isValid.value) {
        if (localEntity.value.groupName) {
          delete localEntity.value.name;
          let request;
          if (localEntity.value.id) {
            request = groupApi.save({
              id: localEntity.value.id,
              patch: {
                description: localEntity.value.description,
                groupName: localEntity.value.groupName
              }
            });
          } else {
            request = groupsApi.save(localEntity.value);
          }
          request.then(r => {
            emit('apply');
          });
        }
      }
    }

    function close() {
      emit('close');
    }

    function copy() {
      copyToClipboard(localEntity.value.id);
    }

    onMounted(async () => {
      refs.form.reset();
      await root.$nextTick();
      localEntity.value = { ...props.group };
    });

    const handleDeleteGroup = () => {
      modalComposition.modal.show({
        component: () => import('@/components/app-entity/modals/AppDialog.vue'),
        bind: {
          nameModal: 'DeleteGroup'
        },
        slots: {
          default: {
            component: () =>
              import('@/components/app-entity/modals/DefaultConfirmation'),
            bind: {
              textDelete: 'Delete this group completely?'
            },
            on: {
              delete() {
                groupApi.remove(localEntity.value.id).then(() => {
                  emit('remove', localEntity.value.id);
                  modalComposition.modal.hide('DeleteGroup');
                  if (root.$route.params.groupId === localEntity.value.id) {
                    root.$router.push('/users/all');
                  }
                });
              },
              close() {
                modalComposition.modal.hide('DeleteGroup');
              }
            }
          }
        }
      });
    };

    return {
      close,
      apply,
      required,
      localEntity,
      groups: groups.value,
      errors,
      copy,
      confirm,
      isValid,
      handleDeleteGroup
    };
  }
};
</script>

<style lang="sass"></style>
